import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { isEmpty, isEqual, cloneDeep } from 'lodash';
import Sortable from 'sortablejs';
var BASIC_HEADERS_VD = [{
  name: '_time',
  disabled: true,
  preselected: true
}, {
  name: '_value',
  disabled: true,
  preselected: true
}, {
  name: 'unit',
  preselected: true
}, {
  name: 'dtwin_id',
  preselected: true
}, {
  name: 'dtwin_title',
  preselected: true
}, {
  name: 'state_id',
  preselected: true
}, {
  name: 'state_identifier',
  preselected: true
}, {
  name: 'state_title',
  preselected: true
}, {
  name: 'external_id',
  preselected: true
}];
var BASIC_HEADERS_DT = [{
  name: '_time',
  disabled: true,
  preselected: true
}, {
  name: '_value',
  disabled: true,
  preselected: true
}, {
  name: 'unit',
  preselected: true
}, {
  name: 'dtwin_id',
  preselected: true
}, {
  name: 'dtwin_title',
  preselected: true
}, {
  name: 'state_id',
  preselected: true
}, {
  name: 'state_identifier',
  preselected: true
}, {
  name: 'state_title',
  preselected: true
}];
export default {
  name: 'CoreCsvExportFormattingOptions',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          headers: [],
          includeHeaders: true
        };
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    filterType: {
      type: String,
      required: true,
      default: 'digitalTwin'
    }
  },
  data: function data() {
    return {
      internalModel: _objectSpread({}, this.value),
      headers: [],
      includeHeaders: true,
      staticHeaders: this.filterType === 'digitalTwin' ? cloneDeep(BASIC_HEADERS_DT) : cloneDeep(BASIC_HEADERS_VD)
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])), {}, {
    themeMode: function themeMode() {
      return Boolean(this.$store.state.app.UiTheme) ? 'dark' : 'light';
    },
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          text: '',
          sortable: false
        }, {
          text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.position'),
          sortable: false
        }, {
          text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.originalColumnName'),
          sortable: false
        }, {
          text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.newColumnName'),
          sortable: false
        }]
      };
    },
    mapValuesRules: function mapValuesRules() {
      var _this = this;

      return [function (v) {
        return !/[,;]/.test(v) || _this.$i18n_t('Common.commasNotAllowed');
      }, function (v) {
        return !_this.headers.find(function (f) {
          return f.name === v;
        }) || _this.$i18n_t('Common.uniqueValue');
      }];
    }
  }),
  watch: {
    internalModel: {
      handler: function handler() {
        this.emitInput();
      },
      deep: true
    },
    value: {
      handler: function handler(newValue) {
        if (!isEqual(newValue, this.internalModel)) {
          this.internalModel = _objectSpread({}, this.value);
        }
      },
      deep: true
    },
    filterType: function filterType() {
      this.setHeaders();
    },
    headers: function headers() {
      this.initSortableTable();
      this.emitInput();
    },
    includeHeaders: function includeHeaders() {
      this.emitInput();
    }
  },
  mounted: function mounted() {
    if (this.internalModel && !isEmpty(this.internalModel)) {
      if (isEmpty(this.internalModel.headers)) {
        this.setHeaders();
      } else {
        this.headers = this.internalModel.headers;
      }

      this.includeHeaders = this.internalModel.includeHeaders;
    } else {
      this.setHeaders();
    }

    this.initSortableTable();
  },
  methods: {
    initSortableTable: function initSortableTable() {
      var _this2 = this;

      var table = document.querySelector('.states-table tbody');
      Sortable.create(table, {
        handle: '.handle',
        onEnd: function onEnd(_ref) {
          var _this2$headers;

          var newIndex = _ref.newIndex,
              oldIndex = _ref.oldIndex;

          (_this2$headers = _this2.headers).splice.apply(_this2$headers, [newIndex, 0].concat(_toConsumableArray(_this2.headers.splice(oldIndex, 1))));

          _this2.emitInput();
        }
      });
    },
    emitInput: function emitInput() {
      var _this3 = this;

      this.$emit('input', {
        headers: this.headers,
        includeHeaders: this.includeHeaders,
        formIsValid: this.includeHeaders ? !this.headers.some(function (el) {
          return el.mappedValue && /[,;]/.test(el.mappedValue);
        }) && !this.headers.some(function (element) {
          return _this3.headers.some(function (el) {
            return el.mappedValue && element.name === el.mappedValue;
          });
        }) : true
      });
    },
    setHeaders: function setHeaders() {
      this.staticHeaders = this.headers = (this.filterType === 'digitalTwin' ? cloneDeep(BASIC_HEADERS_DT) : cloneDeep(BASIC_HEADERS_VD)).filter(function (c) {
        return c.preselected;
      });
    }
  }
};